import cx from 'classnames';
import React from 'react';

import './styles/Row.scss';

export type RowSize =
  | 'xxxxxxlarge'
  | 'xxxxxlarge'
  | 'xxxxlarge'
  | 'xxxlarge'
  | 'xxlarge'
  | 'xlarge'
  | 'large'
  | 'medium'
  | 'small'
  | 'xsmall'
  | 'xxsmall'
  | 'xxxsmall'
  | 'xxxxsmall';

export type Props = {
  size?: RowSize;
  flush?: boolean;
  children?: React.ReactNode;
  className?: string;
};

export default class Row extends React.Component<Props> {
  render() {
    const { size = 'xxlarge', flush = false, children, className } = this.props;

    return <div className={cx('Row', !flush && `Row--${size}`, flush, className)}>{children}</div>;
  }
}
